"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Button = _interopRequireDefault(require("../Button"));
var View = function View(_ref) {
  var isOpen = _ref.isOpen,
    toggle = _ref.toggle,
    items = _ref.items,
    totalUsed = _ref.totalUsed;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    open: isOpen,
    onClose: toggle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-8 bg-card"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-3xl font-bold text-dark"
  }, t('settings.storage.modal.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4",
    style: {
      minHeight: 150
    }
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "w-full"
  }, items.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
      className: "py-1"
    }, label), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-right"
    }, value));
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-6 text-right"
  }, t('settings.storage.detail.totalUsed', {
    used: totalUsed
  }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-40",
    onClick: toggle
  }, t('button.okay')))));
};
View.displayName = 'StorageDetailModal';
var _default = exports["default"] = View;
//# sourceMappingURL=index.js.map